import { render } from "./WizardNavigation.vue?vue&type=template&id=9c0fa30c&scoped=true"
import script from "./WizardNavigation.vue?vue&type=script&lang=js"
export * from "./WizardNavigation.vue?vue&type=script&lang=js"

import "./WizardNavigation.vue?vue&type=style&index=0&id=9c0fa30c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c0fa30c"]])

export default __exports__